import { useState } from "react";
import { SortingState } from "@tanstack/react-table";

import { Button } from "ui/button";
import { DataGrid, TableLoader } from "ui/data-grid";
import SmsSimulatorAddPersona from "containers/sms-simulator/sms-simulator-personas/components/persona-modal/add-persona/sms-simulator-add-persona";
import SmsSimulatorEditPersona from "containers/sms-simulator/sms-simulator-personas/components/persona-modal/edit-persona/sms-simulator-edit-persona";
import { createSmsSimulatorPersonasColumns } from "containers/sms-simulator/sms-simulator-personas/sms-simulator-personas-table-columns";

import { useDeletePersona, useSmsSimulatorPersonas } from "hooks/api/use-sms-simulator-personas";

import { SmsSimulatorPersonaAttributes } from "containers/sms-simulator/sms-simulator.types";

import { SMS_SIMULATOR_STYLES } from "containers/sms-simulator/sms-simulator.styles";

export const SmsSimulatorPersonas = () => {
  const [isAddPersonaModalOpen, setIsAddPersonaModalOpen] = useState(false);
  const [isEditPersonaModalOpen, setIsEditPersonaModalOpen] = useState(false);
  const [selectedPersona, setSelectedPersona] = useState<SmsSimulatorPersonaAttributes | null>(
    null,
  );

  const { data: personas = [], isLoading } = useSmsSimulatorPersonas();
  const deletePersona = useDeletePersona();

  const handleEditPersona = (id: string) => {
    const persona = personas.find((p: SmsSimulatorPersonaAttributes) => p.id === id);

    if (persona) {
      setSelectedPersona(persona);
      setIsEditPersonaModalOpen(true);
    }
  };

  const handleDeletePersona = async (id: string) => {
    try {
      await deletePersona.mutateAsync(id);
    } catch {
      // Error toast handled in the mutation.
    }
  };

  const columns = createSmsSimulatorPersonasColumns({
    onEdit: handleEditPersona,
    onDelete: handleDeletePersona,
  });

  const [sortingParams, setSortingParams] = useState<SortingState>([{ id: "name", desc: false }]);
  return (
    <div className="flex flex-col h-full px-8 pb-8 overflow-auto">
      <div className="py-4 flex justify-between items-center">
        <h1 className={SMS_SIMULATOR_STYLES.heading}>Personas</h1>
        <Button variant="contained" onClick={() => setIsAddPersonaModalOpen(true)}>
          Add persona
        </Button>
        {isAddPersonaModalOpen && (
          <SmsSimulatorAddPersona setIsAddPersonaModalOpen={setIsAddPersonaModalOpen} />
        )}
        {isEditPersonaModalOpen && selectedPersona && (
          <SmsSimulatorEditPersona
            setIsEditPersonaModalOpen={setIsEditPersonaModalOpen}
            persona={selectedPersona}
          />
        )}
      </div>
      <div>
        <TableLoader isLoading={isLoading} fullScreen />

        {!isLoading &&
          (personas.length ? (
            <DataGrid
              columns={columns}
              data={personas}
              pagination={false}
              sortingParams={sortingParams}
              setSortingParams={setSortingParams}
              manualSorting={false}
            />
          ) : (
            <p className="text-gray-600 font-semibold">There are no personas in the list.</p>
          ))}
      </div>
    </div>
  );
};

export default SmsSimulatorPersonas;
